module.exports = __webpack_public_path__ + "static/media/4.de88e9d4.png";